module.exports = __webpack_public_path__ + "img/lr.177182a8.svg";